import { gql } from '@apollo/client'

export const NARRATIVE_FRAGMENT = gql`
  fragment NarrativeFragment on Narrative {
    id
    name
  }
`
